import { render } from "./sf-ace-editor.vue?vue&type=template&id=46b00dc7"
import script from "./sf-ace-editor.vue?vue&type=script&lang=js"
export * from "./sf-ace-editor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__